var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Sidebar',[_c('DividedSidebarList',{attrs:{"title":_vm.$t('Back_to_meeting'),"subtitle":_vm.toLocaleDateTimeString(_vm.meeting.start),"parent":_vm.meeting,"empty-message":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }